<template>
  <div class="history">
    <div v-for="h in history" :key="h.date" class="row">
      <div class="date">{{ h.date }}</div>
      <div class="items">
        <span v-for="(it, i) in h.items" :key="i" class="item">{{ it }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { history } from '@/data/company';

export default {
  name: 'HistoryList',
  data() { return { history }; },
};
</script>

<style scoped>
.history { display: flex; flex-direction: column; border-bottom: 1px solid var(--line); }
.row { display: flex; gap: 32px; padding: 20px 0; border-top: 1px solid var(--line); }
.date { flex: 0 0 96px; font-size: 18px; font-weight: 700; color: var(--orange); }
.items { display: flex; flex-wrap: wrap; gap: 6px 0; font-size: 16px; line-height: 1.7; color: var(--ink); }
.item + .item::before { content: "·"; color: var(--muted-2); margin: 0 10px; }
@media (max-width: 600px) {
  .row { flex-direction: column; gap: 6px; padding: 16px 0; }
  .date { flex: none; }
  .items { flex-direction: column; gap: 2px; font-size: 15px; }
  .item + .item::before { content: none; }
}
</style>
